__webpack_require__.p = "/simplifier-configurator/";